import { gsap } from "gsap";

const HeroModuleAnimation = () => {
  const containers = document.querySelectorAll(".hero-module");
  if (!containers.length) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const applyAnimations = () => {
    const base = {
      y: 0,
      opacity: 1,
      duration: 0.75,
      ease: "power2.inOut",
    };
    containers.forEach((container) => {
      const overline = container.querySelectorAll(".hero-module__overline");
      const headline = container.querySelectorAll(".hero-module__headline");
      const subline = container.querySelectorAll(".hero-module__subline");
      const text = container.querySelectorAll(".hero-module__text");
      const buttonWrapper = container.querySelectorAll(
        ".buttons-container .btn",
      );

      if (
        !overline.length &&
        !headline.length &&
        !subline.length &&
        !text.length &&
        !buttonWrapper.length
      )
        return;

      if (overline.length) {
        gsap.to(overline, base, 0);
      }

      if (headline.length) {
        gsap.to(headline, base, 0.2);
      }

      if (subline.length) {
        gsap.to(subline, base, 0.4);
      }

      if (text.length) {
        gsap.to(text, base, 0.4);
      }

      if (buttonWrapper.length) {
        gsap.to(
          buttonWrapper,
          {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "back.out(1.7, 0.5)",
            stagger: 0.15,
          },
          0.8,
        );
      }
    });
  };
  applyAnimations();
};

export default HeroModuleAnimation;
